import React from 'react';
import { HTMLView } from 'components/atoms/htmlView';
import { useViewport } from 'components/templates/viewportProvider';
import { CallToAction } from 'components/atoms/callToAction';
import RupeeIcon from 'assets/images/rupee-icon-black.png';
import pdfIconWhite from 'assets/images/pdf-icon.png';
import Row from 'react-bootstrap/Row';
import RupeePinkIcon from 'assets/images/rupee-icon-black.png';

const RentTermsMobile = props => {
  const { data, setIsGetInTouchModalOpen, pdfUrl } = props;
  const { isMobile, height } = useViewport();
  const handleClick = link => {
    window.open(link);
  };

  if (!data) {
    return null;
  }
  return (
    <div
      className={'main-mobile-container'}
      style={{ height }}
      id={'rent-terms'}
    >
      <HTMLView tagName={'h1'} className={'long-title'} html={'Rental Terms'} />
      <HTMLView
        tagName={'h2'}
        className={'short-title'}
        html={'Listing Details'}
      />
      {pdfUrl && (
        <button
          type={'button'}
          className={'download-button'}
          onClick={() => window.open(pdfUrl, '_blank')}
        >
          <img src={pdfIconWhite} alt="pdf icon" />
          <p className={'upper-text'}>DOWNLOAD</p>
          <p className={'lower-text'}>BROCHURE</p>
        </button>
      )}
      <Row className={'row'}>
        <HTMLView tagName={'h3'} className={'title'} html={'Rental Price'} />
        <div className={'currency-div'}>
          <img src={RupeeIcon} alt="Rupees" className={'currency-icon'} />
          <HTMLView
            tagName={'h3'}
            className={'title-description'}
            html={data.rental_price}
          />
        </div>
      </Row>
      <Row className={'row'}>
        <HTMLView tagName={'h3'} className={'title'} html={'Deposit'} />
        <div className={'currency-div'}>
          <img src={RupeeIcon} alt="Rupees" className={'currency-icon'} />
          <HTMLView
            tagName={'h3'}
            className={'title-description'}
            html={data.deposit}
          />
        </div>
      </Row>
      <Row className={'row'}>
        <HTMLView
          tagName={'h3'}
          className={'title'}
          html={'Max Rent Duration'}
        />
        <HTMLView
          tagName={'h3'}
          className={'title-description'}
          html={data.max_rent_duration}
        />
      </Row>
      <Row className={'row'}>
        <HTMLView
          tagName={'h3'}
          className={'title'}
          html={'Availability Starting'}
        />
        <HTMLView
          tagName={'h3'}
          className={'title-description'}
          html={data.availability}
        />
      </Row>
      <Row className={'row'}>
        <HTMLView tagName={'h3'} className={'title'} html={'Currently'} />
        <HTMLView
          tagName={'h3'}
          className={'title-description'}
          html={data.currently}
        />
      </Row>
      <Row className={'row'}>
        <HTMLView
          tagName={'h3'}
          className={'title'}
          html={'Annual Rent Increase'}
        />
        <HTMLView
          tagName={'h3'}
          className={'title-description'}
          html={data.annual_rent_increase}
        />
      </Row>
      <img
        src={data.rental_mobile_image}
        alt="image"
        className={'main-image'}
      />
      <CallToAction
        text={'Book Now'}
        onClick={() => setIsGetInTouchModalOpen(true)}
        className={'explore'}
        mode={'dark'}
      />
    </div>
  );
};
export default RentTermsMobile;
